import React, { PureComponent } from 'react';

import DocBlockChooser from './doc-block-chooser';

export default class DocNodeWithChooser extends PureComponent {
    state = {
        overNode: false
    }

    handleMouseEnter = event => {
        this.setState({
            overNode: true
        });
    }

    handleMouseLeave = event => {
        this.setState({
            overNode: false
        });
    }

    componentDidUpdate() {
        const elementMain = document.querySelector('.document-editor-main');

        if (this.element && this.chooserCtrl && elementMain) {
            const elementRect = this.element.getBoundingClientRect();
            const parentModal = elementMain.closest('.modal-document');
            let left = elementRect.left;

            if (parentModal) {
                left -= parentModal.getBoundingClientRect().left;
            }

            this.chooserCtrl.updatePosition({
                left,
                top: elementRect.top - elementMain.getBoundingClientRect().top + elementRect.height / 2
            });
        }
    }

    get element() {
        return this.props.element;
    }

    render() {
        if (this.props.depth !== 1 || !this.props.items.length) {
            return this.props.children;
        }
        const childrenWithProps = React.Children.map(this.props.children, child => {
            return React.cloneElement(child, {
                onMouseEnter: this.handleMouseEnter,
                onMouseLeave: this.handleMouseLeave
            });
        });

        return (
            <React.Fragment>
                { childrenWithProps }

                <DocBlockChooser current={this.props.current} overNode={this.state.overNode} items={this.props.items} onAction={this.props.onAction} provideController={ctrl => this.chooserCtrl = ctrl} />
            </React.Fragment>
        );
    }
}
